export const languages = {
  vi: "VI",
  en: "EN",
};
